import { AdminSelfPasswordUpdate } from "@/components/admin/AdminSelfPasswordUpdate";

export default function ChangePasswordPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Change My Password</h2>
        <p className="text-muted-foreground">Update your own admin password</p>
      </div>
      <AdminSelfPasswordUpdate />
    </div>
  );
}
